import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useState } from 'react'
import { authClient } from '../lib/auth'
import { m } from '../paraglide/messages'

export const Route = createFileRoute('/login')({
  component: LoginPage,
})

function LoginPage() {
  const navigate = useNavigate()
  const [email, setEmail]       = useState('')
  const [password, setPassword] = useState('')
  const [error, setError]       = useState('')
  const [pending, setPending]   = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setPending(true)
    try {
      const result = await authClient.signIn.email({ email, password })
      if (result.error) {
        setError(result.error.message ?? m.login_failed())
      } else {
        navigate({ to: '/lessons' })
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : m.login_failed())
    } finally {
      setPending(false)
    }
  }

  return (
    <div className="min-h-dvh bg-white flex items-start justify-center pt-24">
      <div className="w-full max-w-sm px-4">
        <h1 className="text-base font-semibold text-zinc-900 mb-6">{m.login_title()}</h1>
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div className="flex flex-col gap-1">
            <label className="text-sm text-zinc-700" htmlFor="email">
              {m.login_email()}
            </label>
            <input
              id="email"
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="border border-zinc-300 px-2 py-1.5 text-sm w-full focus:outline-none focus:border-zinc-900"
            />
          </div>

          <div className="flex flex-col gap-1">
            <label className="text-sm text-zinc-700" htmlFor="password">
              {m.login_password()}
            </label>
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="border border-zinc-300 px-2 py-1.5 text-sm w-full focus:outline-none focus:border-zinc-900"
            />
          </div>

          {error && <p className="text-red-600 text-sm">{error}</p>}

          <button
            type="submit"
            disabled={pending}
            className="bg-zinc-900 text-white px-3 py-1.5 text-sm hover:bg-zinc-700 disabled:opacity-40 disabled:cursor-not-allowed"
          >
            {pending ? m.login_submitting() : m.login_submit()}
          </button>
        </form>

      </div>
    </div>
  )
}
